import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './lib/auth';

import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import DocumentDetail from './pages/DocumentDetail';
import Accountant from './pages/Accountant';
import Companies from './pages/Companies';
import WasabiBrowser from './pages/WasabiBrowser';
import IngestLog from './pages/IngestLog';

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            border: '2px solid #000',
            borderRadius: 0,
            fontFamily: 'inherit',
            fontSize: '13px',
            padding: '14px 16px',
          },
          className: 'brutalist-toast',
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="documents" element={<Documents key="all" />} />
            <Route path="documents/:id" element={<DocumentDetail />} />
            <Route path="review" element={<Documents key="review" defaultFilters={{ needs_review: true }} />} />
            <Route path="accountant" element={<Accountant />} />
            <Route path="wasabi" element={<WasabiBrowser />} />
            <Route path="ingest-log" element={<IngestLog />} />
            <Route path="companies" element={<Companies />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
